import React  from 'react';
import { Skeleton, Stack } from "@mui/material";

export default function CalendarHorizontalSkeleton() {
    return (
        <Stack spacing={1}>
            <Skeleton animation="wave" variant="text" />
            <Skeleton animation="wave" variant="rectangular" height={45} />
        </Stack>
    );
}
